/* eslint-disable */
import { Model } from '@vuex-orm/core'

class CTTSubDistrict extends Model {
  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
    }
  }

  static list(options = {}) {
    return this.api().request({
      method: 'GET',
      url: `/chang-tt/sub-districts`,
      ...options,
    }).then((res) => res.response.data)
  }
}

CTTSubDistrict.entity = 'subdistrict'

export default CTTSubDistrict